import React from "react";
import { Link } from "react-router-dom";

const MasonryLayoutV4 = ({ items = [] }) => {
  return (
    <section className="flat-spacing-8">
      <div className="container">
        <div className="masonry-layout-v4 wow fadeInUp" data-wow-delay="0s">
          {items.map((item, index) => {
            // Use offer_id if available, otherwise use the provided link
            const itemLink = item.id
              ? `/shop/default?offer_id=${item.id}`
              : item.link || "/shop/collection";

            return (
              <div
                key={index}
                className={`item-${index + 1} collection-item-v2 hover-img`}
              >
                <Link to={itemLink} className="collection-inner">
                  <div className="collection-image img-style radius-10">
                    <img
                      className="lazyload"
                      data-src={item.image}
                      src={item.image}
                      alt={item.alt || "collection-img"}
                    />
                  </div>
                  <div className="collection-content">
                    {item.title && (
                      <div className="top wow fadeInUp" data-wow-delay="0s">
                        <h5 className="heading text-white">{item.title}</h5>
                        {item.subtitle && (
                          <p className="subheading text-white">
                            {item.subtitle}
                          </p>
                        )}
                        {item.buttonText && (
                          <button className="tf-btn btn-line btn-line-light collection-other-link fw-6">
                            <span>{item.buttonText}</span>
                            <i className="icon icon-arrow1-top-left"></i>
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MasonryLayoutV4;
